<div class="container-fluid">
    @switch (estadoDictaminacion) {
    @case (enumEstadoDictaminacion.CargandoInformacion) {

    }
    @case (enumEstadoDictaminacion.DatosGenerales) {
    <div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
        <div class="card shadow-sm" style="max-width: 800px; width: 100%;">
            <div class="card-body">
                <!-- <h5 class="card-title">Datos de contacto</h5> -->
                <label class="form-label mb-1 tituloDict" for="tipoOrganismoSelect">Dependencia</label>
                <div class="d-flex align-items-center gap-2">
                    <textarea class="form-control multi" readonly value="{{_DataEnrolamiento?.catTipoOrganismo}}"
                        placeholder="Ingrese la denominación de la Autoridad a dar de alta">
                    </textarea>
                </div>

                <label class="form-label mb-1 tituloDict" for="autoridadText">Autoridad</label>
                <div class="d-flex align-items-center gap-2">
                    <textarea class="form-control multi" readonly value="{{_DataEnrolamiento?.autoridad}}"
                        placeholder="Ingrese la denominación de la Autoridad a dar de alta">
                    </textarea>
                </div>

                <label class="form-label mb-1 tituloDict" for="solicitanteText">Solicitante</label>
                <div class="d-flex align-items-center gap-2">
                    <textarea class="form-control multi" readonly value="{{_DataEnrolamiento?.solicitante}}"
                        placeholder="Ingrese su nombre completo, como la persona servidora pública que está realizando la solicitud para dar de alta a la Autoridad en la plataforma">
                    </textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
        <div class="card shadow-sm" style="max-width: 800px; width: 100%;">
            <div class="card-body">
                <h5 class="card-title">Datos de contacto</h5>
                <label class="form-label mb-1 tituloDict" for="solicitanteText">Correo oficial de la institución</label>
                <div class="d-flex align-items-center gap-2">
                    <input type="text" readonly class="form-control" value="{{_DataEnrolamiento?.correoInstitucion}}"
                        placeholder="Ingrese el correo electrónico oficial de la autoridad en el cual pueda recibir comunicaciones administrativas de la plataforma, como por ejemplo, verificación de la cuenta y cambio de contraseña">
                </div>

                <label class="form-label mb-1 tituloDict" for="solicitanteText">Correo oficial del solicitante</label>
                <div class="d-flex align-items-center gap-2">
                    <input type="text" readonly class="form-control" value="{{_DataEnrolamiento?.correoSolicitante}}"
                        placeholder="Ingrese su correo electrónico institucional en el cual se pueda establecer contacto en caso de alguna duda con el registro de alta solicitado">
                </div>

                <label class="form-label mb-1 tituloDict" for="solicitanteText">Teléfono institucional del
                    solicitante</label>
                <div class="d-flex align-items-center gap-2">
                    <input type="text" readonly class="form-control" value="{{_DataEnrolamiento?.telSolicitante}}"
                        placeholder="Ingrese su número de teléfono institucional en el cual se pueda establecer contacto en caso de alguna duda con el registro de alta solicitado">
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
        <div class="col-12 col-sm-auto">
            @if(isFileComplete){
            <oaj-lista-archivos-itx class="form-control" [archivos]="lstDocumentos" [verBorrar]="false"
                [verPrevisualizar]="true" [OcultaSystemName]="false">
            </oaj-lista-archivos-itx>
            }
        </div>
    </div>
    <div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
        @if(_DataEnrolamiento?.status === 4){
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#dialogConfirm"
                (click)="fnSetMensajeDialog(enumAccionDictamen.Aceptar)">
                Aceptar Dictamen
            </button> <br><br>
            <button type="button" class="btn btn-danger" (click)="fnRechazarDictamenPrev()">
                Rechazar Dictamen
            </button>

        </div>
        }
        @else if(_DataEnrolamiento?.status === 1){
        <div class="p-3 mb-2 bg-info text-white">Registro pendiente de dictamen.</div>
        }
        @else {
        <div class="p-3 mb-2 bg-info text-white">El Registro ya fue dictaminado.</div>
        }

    </div>
    <button type="button" class="btn btn-warning btn-lg btn-block btnRegresar"
        (click)="regresarClick(1,'Cancelar')">Regresar</button>


    }
    @case (enumEstadoDictaminacion.ConfirmaCorreo) {
    <div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
        <form [formGroup]="correoForm" (ngSubmit)="SendCorreoOK()">
            <div class="card shadow-sm" style="max-width: 800px; width: 100%;">
                <div class="card-header">
                    <div class="p-3 mb-2 bg-success text-white">Proceso de dictaminación exitoso, debe enviar la
                        respuesta a la autoridad.</div>
                </div>
                <div class="card-body">
                    <span class="input-group-text tituloInput">Mensaje:</span>
                    <label class="form-label mb-1 tituloDict" for="solicitanteText">
                        {{responseAutoenrolamiento?.leyenda}}
                    </label>
                    <br>
                    <br>
                    <br>
                    <span class="input-group-text tituloInput">Comentarios adicionales</span>
                    <div class="d-flex align-items-center gap-2">
                        <textarea class="form-control" aria-label="With textarea" rows="5" maxlength="5000"
                            formControlName="sMensajeCorreo"
                            placeholder="Ingrese comentarios  adicionales que considere relevantes para el registro de alta de la autoridad en la plataforma"></textarea>
                        @if(correoForm.get('sMensajeCorreo')?.invalid &&
                        correoForm.get('sMensajeCorreo')?.hasError('maxlength') &&
                        correoForm.get('sMensajeCorreo')?.touched){
                        <small class="text-danger">
                            El campo excede el límite de 5000 caracteres.
                        </small>
                        }
                    </div><br><br>
                </div>
                <div class="card-footer text-muted">
                    <span class="text-muted">Nota: Con la acción de aceptar, se enviará un correo a la cuenta de la
                        autoridad con los datos de acceso a la plataforma y el micrositio de soporte.</span> <br><br>
                    <div class="d-grid gap-2 col-6 mx-auto">
                        <button type="button" class="btn btn-primary" data-bs-toggle="modal" [disabled]="correoForm.invalid"
                            data-bs-target="#dialogConfirm" (click)="fnSetMensajeDialog(3)">
                            Enviar correo de notificación.
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
    }
    @case (enumEstadoDictaminacion.DictamenNotificado) {
    <div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
        <div class="card shadow-sm" style="max-width: 800px; width: 100%;">
            <div class="card-header">
                <div class="p-3 mb-2 bg-success text-white">El Registro ya fue dictaminado.</div>
            </div>
            <div class="card-body">
                <h5 class="card-title">Se envió correo de notificación de alta.</h5>
            </div>
        </div>
    </div>
    <button type="button" class="btn btn-warning btn-lg btn-block btnRegresar"
        (click)="regresarClick(2,'El Registro ya fue dictaminado.')">Regresar</button>

    }
    @case (enumEstadoDictaminacion.DictamenNoNotificado) {
    <div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
        <div class="card shadow-sm" style="max-width: 800px; width: 100%;">
            <div class="card-header">
                <div class="p-3 mb-2 bg-success text-white">El Registro ya fue dictaminado como rechazado.</div>
            </div>
            <div class="card-body">
                <h5 class="card-title">Se envió un correo a la cuenta de la autoridad con la
                    respuesta del por qué no procedió la solicitud de alta de la autoridad en cuestión.</h5>
            </div>
        </div>
    </div>
    <div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
        <button type="button" class="btn btn-warning btn-lg btn-block btnRegresar btnRegresar"
            (click)="regresarClick(3,'El Registro ya fue dictaminado como rechazado.')">Regresar</button>
    </div>
    }
    @case (enumEstadoDictaminacion.CorreoRechazoDictamen) {
    <div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
        <form [formGroup]="correoRechazoForm" (ngSubmit)="SendCorreoRechazo()">
            <div class="card shadow-sm" style="max-width: 800px; width: 100%;">
                <div class="card-body">
                    <div class="p-3 mb-2 bg-warning text-dark rechazo">Rechazo de dictamen</div>
                    <span class="input-group-text tituloInput">Capturar respuesta</span>
                    <div class="d-flex align-items-center gap-2">
                        <textarea class="form-control" aria-label="With textarea" rows="5" maxlength="5000"
                            formControlName="sMensajeCorreoRechazo"
                            placeholder="Capturar la respuesta del por qué no procedió la solicitud de alta de la autoridad en cuestión"></textarea>
                        @if(correoRechazoForm.get('sMensajeCorreoRechazo')?.invalid &&
                        correoRechazoForm.get('sMensajeCorreoRechazo')?.hasError('required') &&
                        correoRechazoForm.get('sMensajeCorreoRechazo')?.touched){
                        <small class="text-danger">
                            Campo obligatorio.
                        </small>
                        }
                        @if(correoRechazoForm.get('sMensajeCorreoRechazo')?.invalid &&
                        correoRechazoForm.get('sMensajeCorreoRechazo')?.hasError('maxlength') &&
                        correoRechazoForm.get('sMensajeCorreoRechazo')?.touched){
                        <small class="text-danger">
                            El campo excede el límite de 5000 caracteres.
                        </small>
                        }

                    </div>
                </div>
                <div class="card-footer text-muted">
                    <span class="text-muted">Nota: Con la acción de aceptar, se enviará un correo a la cuenta de la
                        autoridad
                        con la respuesta del por qué no procedió la solicitud de alta de la autoridad en
                        cuestión.</span> <br><br>
                    <div class="container">
                        <div class="row">

                        </div>
                        <div class="row">
                            <div class="col">

                            </div>
                            <div class="col d-flex justify-content-end">
                                <button type="button" class="btn btn-success me-3" data-bs-toggle="modal" [disabled]="correoRechazoForm.invalid"
                                    data-bs-target="#dialogConfirm" (click)="fnSetMensajeDialog(4)">
                                    Aceptar
                                </button>
                                <button type="button" class="btn btn-danger" [disabled]="correoRechazoForm.invalid" (click)="fnCancelarRechazo()">
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    }
    }



    <oaj-loader-itx [loading]="isLoading" [sMensaje]="sMensajeLoad" [failed]="isFailed" [loadingClass]="isLoadingClass"
        [sMensajeError]="sMensajeError">
    </oaj-loader-itx>

    <div class="d-flex align-items-center justify-content-center min-vh-90 bg-light p-3">
        <oaj-alert-itx></oaj-alert-itx>
    </div>
</div>



<!-- Modal -->
<div class="modal fade" id="dialogConfirm" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="dialogConfirmLabel" aria-hidden="true">
    <div class="modal-dialog" #dlg>
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="dialogConfirmLabel">{{sHeaderModal}}</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                {{sMensajeModal}}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                    (click)="fnConfitrmarModal()">Aceptar</button>
            </div>
        </div>
    </div>
</div>